import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53d29138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Hide Status Bar ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "incredi-icon incredicon-minimize !text-[20px] ml-1 !-mr-2" }, null, -1))

import { IKPageSize } from '@/types/injectionKeys';
import { IncrediButton } from 'incredi-ui';
import transitionWrapper from '@/components/TransitionWrapper.vue';
import StatusBar from '@/components/status-bar/status-bar.vue';
import { useMatomo } from '@/services/matomo/matomo.service';
import { inject } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-bar-status-bar',
  props: {
    isTopDashboardVisible: { type: Boolean }
  },
  emits: ["toggleTopDashboard"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'toggleTopDashboard', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const size = inject(IKPageSize);
const matomo = useMatomo();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(transitionWrapper, {
      value: __props.isTopDashboardVisible,
      name: "agents"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(IncrediButton), {
            class: "hide-status-bar-button table-upper-buttons text-Text/text_high mb-1 border-radius-[2px]",
            design: "master",
            size: "small",
            "data-testid": "hide-status-bar-button",
            onClick: _cache[0] || (_cache[0] = 
            () => {
              emit('toggleTopDashboard', !__props.isTopDashboardVisible);
              _unref(matomo)?.trackEvent({
                category: 'Agents Page',
                action: 'Hide/Show Status Bar',
                value: 0,
              });
            }
          )
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createVNode(StatusBar, {
          class: _normalizeClass({ 'status-bar-breakpoint-filter-open': (_unref(size)?.width as number) <= 1250 && _unref(store).getters['main/leftDrawer'] })
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})